import { render } from "./DetailedProjectInvestment.vue?vue&type=template&id=1ebc618e&scoped=true"
import script from "./DetailedProjectInvestment.vue?vue&type=script&lang=js"
export * from "./DetailedProjectInvestment.vue?vue&type=script&lang=js"

import "./DetailedProjectInvestment.vue?vue&type=style&index=0&id=1ebc618e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebc618e"]])

export default __exports__